"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEB_SOCCER_TEAMS_DEFAULT_SETTINGS = exports.TRACE_ID_DEFAULT_SETTINGS = exports.DEFAULT_SETTINGS = void 0;

var _helpers = require("../../util/helpers");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var DEFAULT_SETTINGS = {
  muted: true,
  zoomEnabled: (0, _helpers.isSmallMobileScreen)(),
  speed: 1,
  loopMomentPlay: false
};
exports.DEFAULT_SETTINGS = DEFAULT_SETTINGS;
var TRACE_ID_DEFAULT_SETTINGS = {
  muted: true,
  zoomEnabled: (0, _helpers.isSmallMobileScreen)(),
  speed: 1,
  loopMomentPlay: false
};
exports.TRACE_ID_DEFAULT_SETTINGS = TRACE_ID_DEFAULT_SETTINGS;
var WEB_SOCCER_TEAMS_DEFAULT_SETTINGS = {
  muted: true,
  zoomEnabled: (0, _helpers.isSmallMobileScreen)(),
  speed: 1,
  loopMomentPlay: true
};
exports.WEB_SOCCER_TEAMS_DEFAULT_SETTINGS = WEB_SOCCER_TEAMS_DEFAULT_SETTINGS;